<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type='primary' @click="saveqcm" :loading="btnLoading">保存</el-button>
      <vxe-button type='primary' v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="">{{btn.btnname}}</vxe-button>
    </div>
    <div class="main">
      <el-form :model="qcm" ref="ruleForm" label-position="right" class="mainfrom from_input">
        <div class="row">
          <el-form-item label="顺序号" prop="qcmseq" verify int :gt="0">
            <el-input v-model="qcm.qcmseq" :maxlength="6" :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="初审类型" prop="qcmchecktype" verify>
            <el-select v-model="qcm.qcmchecktype" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in qcmchecktypeList" :label="item.label" :value="item.value"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="初审内容" prop="qcmcheckcontent" verify>
            <el-input v-model="qcm.qcmcheckcontent" :maxlength="5000" :autosize="{ minRows: 15}"  show-word-limit type="textarea" :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <!--<div class="row">-->
          <!--<el-form-item label="初审要求"  prop="qcmcheckdemand" verify>-->
            <!--<el-input v-model="qcm.qcmcheckdemand" :maxlength="255" show-word-limit type="textarea" :disabled="disable"></el-input>-->
          <!--</el-form-item>-->
        <!--</div>-->
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  import vggrid from '../common/vggrid'
  export default {
    name: "qcmFrom",
    mixins: [common],
    data () {
      return {
        qcm:{},
        qcmchecktypeList:[],
        disable:false,
        loading:false,
        btnLoading:false
      }
    },
    created () {},
    activated () {
      this.init()
      this.getqcmtypeList()
      this.getqcmList()
    },
    watch: {},
    filters: {},
    components: {vggrid},
    computed: {
    },
    deactivated () {
    },
    methods: {
      async init(){
        this.qcm=this.$route.params.form
      },
      async getqcmtypeList(){
        this.qcmchecktypeList = await request({
            url: '/kfgl/syscode/getSysCodeList',
            method: "get",
            params: {syscode: 'qcmchecktype'}
        })
      },
      async saveqcm(){
        this.loading = true
        this.submitForm('ruleForm').then(async() => {
          let rec = await request({
            method: 'post',
            url: '/ywgl/qcm/saveqcm',
            data: this.qcm
          })
          if(+rec.issuccess === 1){
            this.close()
          }
        }).catch((err) => {
            console.log('======err======',err);
        })
        this.loading = false
      },
      async getqcmList(){
        if(this.qcm.qcmid !== 0){
          let rec = await request({
            method: 'get',
            url: '/ywgl/qcm/getqcmList',
            params: this.qcm
          })
          this.qcm = rec[0]
          this.qcm.qcmchecktype = this.qcm.qcmchecktype?this.qcm.qcmchecktype.toString():this.qcm.qcmchecktype
        }
      },
      close () {
          this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
    }
  }
</script>

<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea {
      width: 520px;
    }
  }
</style>
